import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { AgentStudioBreadcrumbs } from '../AgentStudioBreadcrumbs'

export const AgentStudioSchedulesPage = () => {
  return (
    <>
      <AgentStudioBreadcrumbs title="Schedules" />
      <SectionLayout>Schedules Page</SectionLayout>
    </>
  )
}
